import { Component, OnInit } from '@angular/core';
import { AdminPasswordResetService } from './service/admin-password-reset.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-admin-password-reset',
	templateUrl: './admin-password-reset.component.html',
	styleUrl: './admin-password-reset.component.scss',
})
export class AdminPasswordResetComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_reset_de_senha: '',
		lbl_clique_confirmar_acao: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_email: '',
		lbl_geral_senha: '',
		lbl_successful_updated: '',
		lbl_geral_atualizar: '',
		lbl_gerar_nova_senha: '',
	};

	constructor(
		private AdminPasswordResetService: AdminPasswordResetService,
		private NotificationService: NotificationService,
		private LabelsService: LabelsService
	) {}

	isLoadingLabels = true;

	userEmail = '';
	newPassword = '';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe({
			next: (labels) => {
				this.labels = labels;
			},
			complete: () => {
				this.isLoadingLabels = false;
			},
		});
		this.newPassword = this.generateNewRandomPassword(12);
	}

	generateNewRandomPassword(length): string {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&';
		const charactersLength = characters.length;
		for (let index = 0; index < length; index++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}

	submitNewPassword(): void {
		if (this.userEmail.trim() == '' || this.newPassword.trim() == '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		}
		this.AdminPasswordResetService.resetUserPassword(this.userEmail, this.newPassword).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			},
		});
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}
}
